<template>
  <v-footer app padless absolute v-if="!this.isHome">
    <div class="footer-wrap">
      <div>
        ©{{  2021 }} -
        {{ new Date().getFullYear() }}
        {{blogInfo.webSite.author}}
      </div>
      <a href="https://beian.miit.gov.cn/" target="_blank">
        {{blogInfo.webSite.recordNum}}
      </a>
        <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=35020302035488" target="_blank">
          <img src="https://pic3.zhimg.com/80/v2-d0289dc0a46fc5b15b3363ffa78cf6c7.png" style="display: inline-block; margin: 0px 0px 0px 10px;">
          {{blogInfo.webSite.securityNum}}
        </a>
    </div>
  </v-footer>
</template>

<script>
export default {
  computed: {
    isHome() {
      return this.$route.path.includes("/book-pdf") || this.$route.path.includes("/memo");
    },
    blogInfo() {
      return this.$store.state.blogInfo;
    }
  }
};
</script>

<style scoped>
.footer-wrap {
  width: 100%;
  line-height: 2;
  position: relative;
  padding: 20px 20px;
  color: #eee;
  font-size: 14px;
  text-align: center;
  background: linear-gradient(-45deg, white, rgb(160, 160, 160), rgb(173, 238, 222));
  background-size: 400% 400%;
  animation: Gradient 10s ease infinite;
}
.footer-wrap a {
  color: #eee !important;
}
@keyframes Gradient {
  0% {
    background-position: 0 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}
</style>
